var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSovrynSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.495749 0.486218H0.242432L8.05824 15.2859L15.8718 0.484863H15.6196L8.0596 11.3576L0.495749 0.486218ZM6.09141 7.04696L8.05722 9.8786L12.3042 3.77234L6.79108 3.76738L5.81394 2.36375L13.2834 2.36691L14.5922 0.484863H1.52222L5.11268 5.64107H8.89032L7.91972 7.04696H6.09141Z",
    fill: "#E6E6E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovrynSmallLogo);
export default __webpack_public_path__ + "static/media/sovryn-small-logo.5c046f52ef7573a45da1d9125799eaa4.svg";
export { ForwardRef as ReactComponent };